import React, { useLayoutEffect, useRef } from 'react';
import './intro.scss';
import { lang } from '../lang';
import HyperLink from '../../components/Hyperlink/Hyperlink';

function Intro() {
  const headRef = useRef();
  const copyRef = useRef();
  const subheadRef = useRef();
  const { head, hyperlinkdata, subhead, copy } = lang.intro;

  useLayoutEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.3) {
            entry.target.style.animation = 'fade-up 0.5s linear forwards';
          }
        });
      },
      { threshold: [0, 0.3] }
    );

    observer.observe(headRef.current);
    observer.observe(subheadRef.current);
  }, []);

  useLayoutEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.1) {
            entry.target.style.animation = 'fade-up 0.5s linear forwards';
          }
        });
      },
      { threshold: [0, 0.1] }
    );
    observer.observe(copyRef.current);
  }, []);
  return (
    <section className="intro">
      <h1 ref={headRef}>
        {head[0]}
        <span className="intro__stem">{head[1]}</span>
        <br />
        {head[2]}
      </h1>
      <h2 ref={subheadRef}>
        {subhead[0]}
        <HyperLink hyperlinkData={hyperlinkdata} />
        {subhead[1]}
      </h2>
      <div className="intro__copy" ref={copyRef}>
        {copy.map((p, i) => {
          return (
            <p key={`intro-${i}`} className={i === 0 ? 'intro__1st' : ''}>
              {p}
            </p>
          );
        })}
      </div>
    </section>
  );
}

export default Intro;
